module.exports = __webpack_public_path__ + "static/media/video-early-warning-en.811873f4.vtt";